// removed by extract-text-webpack-plugin
module.exports = {"searchBoxWrapper":"search-box-wrapper--JRYSj","searchIcnWrapper":"search-icn-wrapper--dA7t5","searchIcn":"search-icn--oOsiD","searchBoxInput":"search-box-input--HecWD"};


//////////////////
// WEBPACK FOOTER
// ./app/components/commons/searchBox/searchBox.scss
// module id = lsZE
// module chunks = 1